module.exports = __webpack_public_path__ + "static/media/Chests.432b6416.png";